import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const AdminCardView = ({ admin, onEdit }) => {
  const { t } = useTranslation();
  return (
  <div className='o-card__wrap o-admin-card'>
    <section className='column o-card cs-bg--light'>
      <h3><b>{admin.name}</b></h3>
      {admin.is_administrator && (<p>
        <i>{t('administration.staff.columns.adminLevelAccess')}</i>
      </p>)}
      <p>
        {t('administration.staff.status.label')}{admin.archived ? t('administration.staff.status.archived') : t('administration.staff.status.active')}
      </p>
      <p>
        {t('administration.staff.adminUserTypeLabel')}{admin.partner_custom_tag_association?.partner_custom_tag_label}
      </p>
      <p className='cs-txt-link--sp-blue'>
        <a href={`mailto:${admin.email}`} target='_blank' rel='noreferrer'>
          <b>{admin.email}</b>
        </a>
      </p>
      <div className='u-flex'>
        <a className='o-sp-button o-sp-button--update o-sp-button--primary' onClick={onEdit}>
          {t('administration.staff.edit')}
        </a>
      </div>
    </section>
  </div>
  );
};


AdminCardView.propTypes = {
  admin: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default AdminCardView;
